import { CAST_AI, EXTERNAL_LINKS } from '@cast/constants';
import {
  Button,
  ExternalLink,
  Typography,
  Stack,
  tokens,
  colorOrToken,
} from '@cast/design-system';

import { LogoSmallSvg, TerraformSvg } from 'assets/svg';

export const TerraformTabContent = () => {
  return (
    <Stack gap={16} data-testid="terraform-tab-content">
      <Typography variant="P12R" color="textSecondary">
        Manage your {CAST_AI} cluster configuration as code with Terraform.
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={12}
        p={12}
        pr={24}
        bgcolor={colorOrToken(
          'common.white',
          tokens.theme.bg.structural.surface
        )}
        borderRadius="4px"
        border="1px solid"
        borderColor={tokens.theme.border.structural.neutral}
      >
        <Stack direction="row" alignItems="center" gap={12}>
          <Stack
            bgcolor={colorOrToken(
              'blue.50',
              tokens.theme.bg.categorical.blueSubtle
            )}
            p={8}
            borderRadius="4px"
            alignItems="center"
            justifyContent="center"
          >
            <LogoSmallSvg />
          </Stack>
          <Typography variant="h6">castai</Typography>
        </Stack>

        <Button
          variant="text"
          component={ExternalLink}
          link={EXTERNAL_LINKS.castai_terraform}
          startIcon={<TerraformSvg />}
        >
          Terraform
        </Button>
      </Stack>
    </Stack>
  );
};
